import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/store/useAuthStore.ts';
import { defaultNotify } from '@/lib/notify';
import i18n from '@/plugins/i18n';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: () => {
        const authStore = useAuthStore();
        return authStore.user ? '/tasks' : '/login';
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginPage.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: () => import('../views/TasksPage.vue'),
      meta: {
        requireAuth: true
      }
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const requireAuth = to.meta.requireAuth;

  const token = to.query?.token as string | undefined;
  if (token && token !== 'undefined') {
    try {
      await authStore.loginWithToken(token);
      return next({ name: 'tasks', replace: true });
    } catch (error) {
      console.error('Token login failed:', error);
      defaultNotify(i18n.global.t('auth.errors.sessionInvalidOrExpired'), 'error', {
        title: i18n.global.t('auth.errors.authenticationFailed')
      });
      return next({ name: 'login', replace: true });
    }
  }

  if (requireAuth && !authStore.user) {
    next('/login');
  } else {
    next();
  }
});

export default router;
